export default "__VITE_ASSET__D$VSQlIM__"